/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Result of attempting to record a savings ledger row. `recorded=false` covers feature-flag-off, missing data, no savings, and idempotent re-records.
 * @export
 * @interface RecordHotelRateUpdateSavingsResponse
 */
export interface RecordHotelRateUpdateSavingsResponse {
    /**
     * True iff a new row was inserted into user_savings_ledger.
     * @type {boolean}
     * @memberof RecordHotelRateUpdateSavingsResponse
     */
    recorded: boolean;
    /**
     * Populated when a row was actually inserted.
     * @type {string}
     * @memberof RecordHotelRateUpdateSavingsResponse
     */
    savingsType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RecordHotelRateUpdateSavingsResponse
     */
    amountSavedUsd?: number | null;
}

/**
 * Check if a given object implements the RecordHotelRateUpdateSavingsResponse interface.
 */
export function instanceOfRecordHotelRateUpdateSavingsResponse(value: object): value is RecordHotelRateUpdateSavingsResponse {
    if (!('recorded' in value) || value['recorded'] === undefined) return false;
    return true;
}

export function RecordHotelRateUpdateSavingsResponseFromJSON(json: any): RecordHotelRateUpdateSavingsResponse {
    return RecordHotelRateUpdateSavingsResponseFromJSONTyped(json, false);
}

export function RecordHotelRateUpdateSavingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordHotelRateUpdateSavingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'recorded': json['recorded'],
        'savingsType': json['savings_type'] == null ? undefined : json['savings_type'],
        'amountSavedUsd': json['amount_saved_usd'] == null ? undefined : json['amount_saved_usd'],
    };
}

export function RecordHotelRateUpdateSavingsResponseToJSON(json: any): RecordHotelRateUpdateSavingsResponse {
    return RecordHotelRateUpdateSavingsResponseToJSONTyped(json, false);
}

export function RecordHotelRateUpdateSavingsResponseToJSONTyped(value?: RecordHotelRateUpdateSavingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recorded': value['recorded'],
        'savings_type': value['savingsType'],
        'amount_saved_usd': value['amountSavedUsd'],
    };
}

